import WeatherRiskBadge from "./WeatherRiskBadge";
import WeatherRiskEvidenceList from "./WeatherRiskEvidenceList";
import WeatherConfidenceBadge from "./WeatherConfidenceBadge";
import WeatherRiskLimitations from "./WeatherRiskLimitations";
import WeatherRiskRecommendations from "./WeatherRiskRecommendations";
import WeatherRiskSourceStatus from "./WeatherRiskSourceStatus";
import {
  formatRiskLevel,
  RAIN_NEARBY_LABELS,
} from "../../../weather/colombiaWeatherRiskApi";

function SignalRow({ label, value }) {
  return (
    <div className="weather-risk-context__signal">
      <span className="weather-risk-context__signal-label">{label}</span>
      <span className="weather-risk-context__signal-value">{value || "—"}</span>
    </div>
  );
}

const WeatherRiskContextCard = ({
  payload,
  loading = false,
  errorMessage = "",
  title = "Weather Risk Context",
  subtitle = "Current local signals",
  onViewInWeather,
  compact = false,
}) => {
  if (loading) {
    return (
      <section className="panel-card weather-risk-context">
        <p className="eyebrow">{title}</p>
        <h3>{subtitle}</h3>
        <p className="muted">Loading weather risk context…</p>
      </section>
    );
  }

  if (errorMessage) {
    return (
      <section className="panel-card weather-risk-context">
        <p className="eyebrow">{title}</p>
        <h3>{subtitle}</h3>
        <p className="muted">{errorMessage}</p>
      </section>
    );
  }

  if (!payload) {
    return null;
  }

  if (payload.available === false) {
    return (
      <section className="panel-card weather-risk-context weather-risk-context--unavailable">
        <p className="eyebrow">{title}</p>
        <h3>{subtitle}</h3>
        <p className="muted" role="status">
          {payload.message ||
            "No fresh weather data is available for this point. Try another location or check back later."}
        </p>
      </section>
    );
  }

  const risk = payload.risk || payload;
  const evidence = payload.evidence;

  return (
    <section className="panel-card weather-risk-context">
      <div className="weather-risk-context__header">
        <div>
          <p className="eyebrow">{title}</p>
          <h3>{subtitle}</h3>
        </div>
        <div className="weather-risk-context__badges">
          <WeatherRiskBadge level={risk.level} />
          <WeatherConfidenceBadge confidence={risk.confidence} />
        </div>
      </div>

      <p className="weather-risk-context__summary">{risk.summary}</p>

      <div className="weather-risk-context__signals">
        <SignalRow
          label="Rain nearby"
          value={RAIN_NEARBY_LABELS[risk.rainNearby] || risk.rainNearby}
        />
        <SignalRow label="Quebrada status" value={formatRiskLevel(risk.quebradaStatus)} />
        <SignalRow
          label="Active alerts"
          value={
            risk.activeAlertCount != null
              ? `${risk.activeAlertCount} nearby${risk.severeAlertCount ? ` (${risk.severeAlertCount} severe)` : ""}`
              : "—"
          }
        />
      </div>

      {!compact ? (
        <>
          <WeatherRiskSourceStatus
            sourceHealth={evidence?.sourceHealth}
            risk={risk}
            evidence={evidence}
          />
          <WeatherRiskEvidenceList evidence={evidence} />
          <WeatherRiskRecommendations recommendations={payload.recommendations} />
          {payload.attribution?.length ? (
            <ul className="weather-risk-context__attribution muted">
              {payload.attribution.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          ) : null}
          <WeatherRiskLimitations
            limitations={payload.limitations}
            disclaimer={payload.disclaimer}
          />
        </>
      ) : null}

      {onViewInWeather ? (
        <button type="button" className="weather-btn weather-btn-secondary" onClick={onViewInWeather}>
          View in Weather perspective
        </button>
      ) : null}
    </section>
  );
};

export default WeatherRiskContextCard;
